export default class  WorkSheetActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_WORKSHEET='GET_HELPER_WORKSHEET';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static PRINT_WORKSHEET='PRINT_WORKSHEET';
  static BEFORE_PRINT_WORKSHEET='BEFORE_PRINT_WORKSHEET';
  static submit(){
    return {
      type:  WorkSheetActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  WorkSheetActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  WorkSheetActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  WorkSheetActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  WorkSheetActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  WorkSheetActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  WorkSheetActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  WorkSheetActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  WorkSheetActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  WorkSheetActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  WorkSheetActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  WorkSheetActions.GET_HELPER_WORKSHEET,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  WorkSheetActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: WorkSheetActions.BEFORE_PRINT_WORKSHEET,
    };
  }
  static print(printWorkSheet){
    return {
      type: WorkSheetActions.PRINT_WORKSHEET,
      payload: printWorkSheet
    };
  }
}